import { render, staticRenderFns } from "./onTheJobInherit.vue?vue&type=template&id=264f5f64&scoped=true&"
import script from "./onTheJobInherit.vue?vue&type=script&lang=js&"
export * from "./onTheJobInherit.vue?vue&type=script&lang=js&"
import style0 from "./onTheJobInherit.vue?vue&type=style&index=0&id=264f5f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f5f64",
  null
  
)

export default component.exports